var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSideBarCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 229,
    height: 148,
    viewBox: "0 0 229 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20218",
    "data-name": "Rectangle 20218",
    width: 229,
    height: 148,
    transform: "translate(1137 133)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_20217",
    x: -37.5,
    y: -37.5,
    width: 304,
    height: 223,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#041c25"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c03dfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62626d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c03dfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a79ef",
    stopOpacity: 0.451
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    transform: "translate(-1137 -133)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63317",
    "data-name": "Group 63317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63316",
    "data-name": "Group 63316",
    transform: "translate(2608.173 -66)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1471.17, 199)",
    filter: "url(#Rectangle_20217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_20217-2",
    "data-name": "Rectangle 20217",
    transform: "translate(0)",
    fill: "#191a2a",
    stroke: "#141525",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0H229a0,0,0,0,1,0,0V148a0,0,0,0,1,0,0H20A20,20,0,0,1,0,128V20A20,20,0,0,1,20,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,.5H228.5a0,0,0,0,1,0,0v147a0,0,0,0,1,0,0H20A19.5,19.5,0,0,1,.5,128V20A19.5,19.5,0,0,1,20,.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_20081",
    "data-name": "Rectangle 20081",
    d: "M23.148,1a24.856,24.856,0,0,0-8.56,1.493A22.387,22.387,0,0,0,7.6,6.565,19.048,19.048,0,0,0,2.885,12.6,16.69,16.69,0,0,0,1.157,20V128a16.69,16.69,0,0,0,1.728,7.4,19.048,19.048,0,0,0,4.713,6.04,22.387,22.387,0,0,0,6.99,4.072A24.856,24.856,0,0,0,23.148,147H229.17V1H23.148m0-1H230.327V148H23.148C10.364,148,0,139.046,0,128V20C0,8.954,10.364,0,23.148,0Z",
    transform: "translate(-1471.081 199)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_36",
    "data-name": "Union 36",
    d: "M1314,155.02,1459.96,9.842h26.62L1340.735,155.02Zm-41,0L1418.96,9.842h26.62L1299.736,155.02Zm-41,0L1377.96,9.842h26.619L1258.735,155.02Zm-41-1.842L1336.96,8h26.62L1217.736,153.177Zm-42,0L1294.96,8h26.62L1175.736,153.177Z",
    transform: "translate(5 125.981)",
    opacity: 0.28,
    fill: "url(#linear-gradient-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarCard);
export default __webpack_public_path__ + "static/media/sideBarCard.b5f3787f27181f5d1ac9268db9310523.svg";
export { ForwardRef as ReactComponent };